export const IntakeFormMenuIcon = () => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        className="base"
      >
        <path
          opacity="0.3"
          d="M18.9711 13C19 12.1557 19 11.1689 19 10C19 6.25027 19 4.3754 18.0451 3.06107C17.7367 2.6366 17.3634 2.26331 16.9389 1.95491C15.6246 1 13.7497 1 10 1C6.25027 1 4.3754 1 3.06107 1.95491C2.6366 2.26331 2.26331 2.6366 1.95491 3.06107C1 4.3754 1 6.25027 1 10C1 13.7497 1 15.6246 1.95491 16.9389C2.26331 17.3634 2.6366 17.7367 3.06107 18.0451C4.3754 19 6.25027 19 10 19C11.1689 19 12.1557 19 13 18.9711M18.9711 13C18.9072 14.8642 18.7023 16.0343 18.0451 16.9389C17.7367 17.3634 17.3634 17.7367 16.9389 18.0451C16.0343 18.7023 14.8642 18.9072 13 18.9711M18.9711 13C18.0613 13 17.6024 13.0006 17.2178 13.0616C15.0784 13.4004 13.4004 15.0784 13.0616 17.2178C13.0006 17.6024 13 18.0613 13 18.9711M6 14H9M6 10H14M6 6H9"
          stroke="#1A1A1A"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        className="active-icon"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9C0 5.25027 0 3.3754 0.954915 2.06107C1.26331 1.6366 1.6366 1.26331 2.06107 0.954915C3.3754 0 5.25027 0 9 0C12.7497 0 14.6246 0 15.9389 0.954915C16.3634 1.26331 16.7367 1.6366 17.0451 2.06107C18 3.3754 18 5.25027 18 9C18 9.83894 18 10.584 17.9893 11.25L17.9192 11.25C17.0672 11.2499 16.5482 11.2499 16.1005 11.3208C13.6401 11.7105 11.7105 13.6401 11.3208 16.1005C11.2499 16.5482 11.2499 17.0672 11.25 17.9192L11.25 17.9893C10.584 18 9.83894 18 9 18C5.25027 18 3.3754 18 2.06107 17.0451C1.6366 16.7367 1.26331 16.3634 0.954915 15.9389C0 14.6246 0 12.7497 0 9ZM5 4.1249C4.58579 4.1249 4.25 4.46068 4.25 5C4.25 5.41421 4.58579 5.87165 5 5.87165H8C8.41421 5.87165 8.75 5.41421 8.75 5C8.75 4.58579 8.41421 4.1249 8 4.1249H5ZM5 8.1613C4.58579 8.1613 4.25 8.58579 4.25 9C4.25 9.41421 4.58579 9.83724 5 9.83724H13C13.4142 9.83724 13.75 9.41421 13.75 9C13.75 8.58579 13.4142 8.1613 13 8.1613H5ZM5 12.0641C4.58579 12.0641 4.25 12.5858 4.25 13C4.25 13.4142 4.58579 13.8785 5 13.8785H8C8.41421 13.8785 8.75 13.4142 8.75 13C8.75 12.5858 8.41421 12.0641 8 12.0641H5Z"
          fill="white"
        />
        <path
          d="M16.4532 12.916C16.7616 12.8672 17.0088 12.9161 17.9192 12.916C17.8248 14.3556 17.6094 15.1622 17.0451 15.9389C16.7367 16.3634 16.3634 16.7367 15.9389 17.0451C15.1622 17.6094 14.36 17.8248 12.9204 17.9192C12.9205 17.0088 12.8716 16.7572 12.9204 16.4488C13.2084 14.6303 14.6347 13.204 16.4532 12.916Z"
          fill="white"
        />
      </svg>
    </span>
  );
};
